import React from "react";
import { useFlags, useLDClient } from "launchdarkly-react-client-sdk";
import { Navigate } from "react-router-dom";
import { FEATURE_FLAGS, FeatureFlagKey } from "../../constants/featureFlags";

interface FeatureFlagGuardProps {
  flag: FeatureFlagKey;
  children: React.ReactNode;
}

export const FeatureFlagGuard: React.FC<FeatureFlagGuardProps> = ({
  flag,
  children,
}) => {
  const flags = useFlags();
  const ldClient = useLDClient();

  if (!ldClient) {
    return null; // or return a loading spinner if preferred
  }

  return flags[FEATURE_FLAGS[flag]] ? (
    <>{children}</>
  ) : (
    <Navigate to="/" replace />
  );
};
